import { BaseService } from '../../infra/base.service'
import type { Automation } from './automation'
import type { AutomationsRepository } from './automation.repository'

export class AutomationsService extends BaseService<Automation> {
    constructor(private rep: AutomationsRepository) {
        super(rep)
    }
}
